// State
export const state = () => ({
	user: {},
	loading: false
})

// Actions
export const actions = {
	async login({ commit, rootGetters }, userData) {
		try {
			commit('setLoading', true)
			return await this.$axios
				.post(`/agents/login`, userData)
				.then((response) => {
					const responseData = response.data
					responseData.token = response.headers.token

					commit('setLogin', responseData)
					this.$toast.success(rootGetters['language-strings/storeTl']('loggedInWelcomeBoard'))

					// Local storing
					this.$cookie.remove('token')
					this.$cookie.set('agentToken', responseData.token, {
						path: "/",
						maxAge: 60 * 60 * 24 - 60,
					})
					this.$cookie.set('agentUser', responseData, {
						path: "/",
						maxAge: 60 * 60 * 24 - 60,
					})
					commit('setLoading', false)
					this.$router.push('/agent/agent/')
					return true
				})
		} catch (error) {
			commit('setLoading', false)
		}
	},

	async logout({ rootGetters }) {
		try {
			await this.$axios.get('/agents/session/logout');
			this.$cookie.remove('agentToken')
			this.$toast.info(rootGetters['language-strings/storeTl']('logoutSeeYou'))
			this.$router.push('/agent')
		} catch (error) {
			this.$toast.error(error)
		}
	},
}

// Mutations
export const mutations = {
	setLogin(state, response) {
		state.user = response
	},
	setLoading(state, type) {
		state.loading = type
	}
}

// Getters
export const getters = {}
